export var DraftType;
(function (DraftType) {
    DraftType["SET_VALUE"] = "draft/set-value";
    DraftType["SET_ARRAY_VALUE"] = "draft/set-array-value";
    DraftType["SET_TOUCHED"] = "draft/set-touched";
    DraftType["SUBMIT_ATTEMPT"] = "draft/submit-attempt";
})(DraftType || (DraftType = {}));
export var ValidationError;
(function (ValidationError) {
    ValidationError["REQUIRED"] = "required";
    ValidationError["EMPTY_ADDRESS"] = "empty address";
    ValidationError["UNAVAILABLE_TARIFF"] = "unavailable tariff";
    ValidationError["UNAVAILABLE_PAYMENT"] = "unavailable payment";
})(ValidationError || (ValidationError = {}));
